(function () {
  // Kör bara en gång per sida, även om skriptet laddas från flera sektioner.
  if (window.__venatWishlist) return;
  window.__venatWishlist = true;

  var KEY = 'venat_wishlist';
  var HEART = "<svg viewBox='0 0 24 24' width='20' height='20' aria-hidden='true' focusable='false'><path d='M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 10c0 5.65-7 10-7 10z'/></svg>";
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(v)) return [];
      var out = [];
      v.forEach(function (h) { if (typeof h === 'string' && h && out.indexOf(h) === -1) out.push(h); });
      return out;
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-v3-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-v3-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-v3-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-v3-wish-link]').forEach(function (a) {
      a.classList.toggle('has-items', list.length > 0);
    });
  }
  function money(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? n.toLocaleString('sv-SE') : n.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s + ' kr';
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function addToCart(btn, id, labels) {
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return fetch(root + 'cart.js');
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-v3-cart-count]').forEach(function (x) { x.textContent = cart.item_count; });
      btn.textContent = labels.added || labels.add;
      setTimeout(function () { btn.textContent = labels.add; btn.disabled = false; }, 1800);
    }).catch(function () { btn.disabled = false; });
  }
  function card(p, labels) {
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0] || variants[0];
    var art = el('article', 'v3-card');
    art.setAttribute('data-v3-wish-item', '');
    var heart = el('button', 'v3-wish v3-wish--card is-on');
    heart.type = 'button';
    heart.setAttribute('data-v3-wish', p.handle);
    heart.setAttribute('aria-pressed', 'true');
    heart.setAttribute('aria-label', labels.remove || '');
    heart.innerHTML = HEART;
    var url = p.url || (root + 'products/' + p.handle);
    var media = el('a', 'v3-media');
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = el('img');
      var src = p.featured_image;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
      img.alt = p.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    var h = el('h3', 'v3-name');
    var a = el('a', null, p.title);
    a.href = url;
    h.appendChild(a);
    art.appendChild(heart);
    art.appendChild(media);
    art.appendChild(h);
    if (v) {
      art.appendChild(el('p', 'v3-price', money(v.price)));
      var wrap = el('div', 'v3-card__form');
      var btn = el('button', 'v3-btn', v.available ? labels.add : labels.sold);
      btn.type = 'button';
      if (!v.available) btn.disabled = true;
      btn.addEventListener('click', function () { addToCart(btn, v.id, labels); });
      wrap.appendChild(btn);
      art.appendChild(wrap);
    }
    return art;
  }
  function renderPage(page) {
    var grid = page.querySelector('[data-v3-wish-grid]');
    var empty = page.querySelector('[data-v3-wish-empty]');
    var list = read();
    grid.textContent = '';
    if (!list.length) { empty.hidden = false; return; }
    empty.hidden = true;
    page.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? 'gone' : null); })
        .catch(function () { return null; });
    })).then(function (products) {
      var current = read();
      var gone = [];
      grid.textContent = '';
      products.forEach(function (p, i) {
        if (p === 'gone') { gone.push(list[i]); return; }
        if (p && current.indexOf(list[i]) > -1) grid.appendChild(card(p, page.dataset));
      });
      if (gone.length) write(current.filter(function (h) { return gone.indexOf(h) === -1; }));
      empty.hidden = grid.children.length > 0;
      page.removeAttribute('aria-busy');
      sync();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-v3-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-v3-wish');
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    sync();
    var page = b.closest('[data-v3-wishlist]');
    if (page && i > -1) {
      var item = b.closest('[data-v3-wish-item]');
      if (item) item.remove();
      if (!page.querySelector('[data-v3-wish-item]')) page.querySelector('[data-v3-wish-empty]').hidden = false;
    }
  });

  function init() {
    sync();
    document.querySelectorAll('[data-v3-wishlist]').forEach(renderPage);
  }
  // Andra flikar ändrade listan
  window.addEventListener('storage', function (e) { if (e.key === KEY) init(); });
  // Tillbaka-knappen visar en sparad kopia av sidan – uppdatera den
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
